import React from "react";
import Helmet from "react-helmet";
import config from "utils/backSiteConfig";

const SEO = ({ locationData, logoImg }) => {

  // Set Default OpenGraph Parameters for Fallback
  const title = config.siteTitle;
  const description = config.siteDescription;
  const image = logoImg.src;
  const imgWidth = logoImg.width;
  const imgHeight = logoImg.height;
  const pageUrl = config.siteUrl + "/" + locationData.location +"/";
  const siteLanguage = config.siteLanguage;

  // Default Website Schema
  const schemaOrgJSONLD = [
    {
      "@context": "http://schema.org",
      "@type": "WebSite",
      url: config.siteUrl,
      name: config.siteTitle,
      alternateName: config.siteTitleAlt
    }
  ];

  return (
    <Helmet defaultTitle={config.siteTitleAlt} titleTemplate={`%s | ${locationData.title}`}>
      {/* General tags */}
      <title>{config.siteTitleAlt}</title>
      <html lang={siteLanguage} />
      <meta name="image" content={image} />
      <meta name="description" content={description} />

      {/* Schema.org tags */}
      <script type="application/ld+json">
        {JSON.stringify(schemaOrgJSONLD)}
      </script>

      {/* OpenGraph tags */}
      <meta property="og:title" content={title} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content={siteLanguage} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content={imgWidth} />
      <meta property="og:image:height" content={imgHeight} />
      <meta property="og:description" content={description} />      
    </Helmet>
  );
};

export default SEO;
